/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Like_NewInputs */

const en_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Like New`)
};

const es_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como nuevo`)
};

const fr_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comme neuf`)
};

const de_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie neu`)
};

const ja_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新品同様`)
};

const zh_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`九成新/几乎全新`)
};

const ar_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شبه جديد`)
};

const id_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seperti Baru`)
};

const it_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come Nuovo`)
};

const ru_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как новое`)
};

const pt_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como Novo`)
};

const ko_val_like_new = /** @type {(inputs: Val_Like_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 제품 같음`)
};

/**
* | output |
* | --- |
* | "Like New" |
*
* @param {Val_Like_NewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_like_new = /** @type {((inputs?: Val_Like_NewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Like_NewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_like_new(inputs)
	if (locale === "es") return es_val_like_new(inputs)
	if (locale === "fr") return fr_val_like_new(inputs)
	if (locale === "de") return de_val_like_new(inputs)
	if (locale === "ja") return ja_val_like_new(inputs)
	if (locale === "zh") return zh_val_like_new(inputs)
	if (locale === "ar") return ar_val_like_new(inputs)
	if (locale === "id") return id_val_like_new(inputs)
	if (locale === "it") return it_val_like_new(inputs)
	if (locale === "ru") return ru_val_like_new(inputs)
	if (locale === "pt") return pt_val_like_new(inputs)
	return ko_val_like_new(inputs)
});